import { AfterViewInit, Component, Input } from '@angular/core';
import { LoggingService } from 'src/app/service/logging-service/logging.service';
import { LocaleOption } from 'web-component-library/projects/component-library/src/public-api';
import {
  LanguageSwitchJson,
  StateService,
} from '@app/service/state/state.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
})
export class FooterComponent implements AfterViewInit {
  @Input() shouldDisplayLocaleSelector: boolean = false;
  @Input() shouldDisplayDisclaimer: boolean = false;

  constructor(
    private loggingService: LoggingService,
    private stateService: StateService
  ) {}
  reportCounter: number = 0;
  activeLocale: string = this.stateService.getCurrentLocale();
  localeOptions: LocaleOption[] = [
    {
      text: 'English',
      locale: 'en-GB',
      flagLink: 'assets/flags/us.svg',
      subPath: 'en',
    },
    {
      text: 'Suomi',
      locale: 'fi-FI',
      flagLink: 'assets/flags/fi.svg',
      subPath: 'fi',
    },
  ];

  ngAfterViewInit() {
    this.stateService.locale$.subscribe((newLocale) => {
      this.activeLocale = newLocale;
    });
  }

  public report() {
    if (this.reportCounter < 8) {
      this.reportCounter++;
      return;
    }
    this.loggingService.manualReport();
    this.reportCounter = 0;
    return;
  }

  localeChanged(option: LocaleOption): void {
    if (this.activeLocale === option.locale) {
      return;
    }

    let languageSwitch: LanguageSwitchJson = {
      language: option.locale,
      token: this.stateService.getToken(),
    };

    this.stateService.postSwitchLanguage(languageSwitch).then(() => {
      window.location.reload();
    });
  }
}
